import { render, staticRenderFns } from "./AlbumImgComponent.vue?vue&type=template&id=12489e39&scoped=true"
import script from "./AlbumImgComponent.vue?vue&type=script&lang=js"
export * from "./AlbumImgComponent.vue?vue&type=script&lang=js"
import style0 from "./AlbumImgComponent.vue?vue&type=style&index=0&id=12489e39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12489e39",
  null
  
)

export default component.exports